<template>
  <div class="pinterest-embed">
    <a
      :href="`https://www.pinterest.com/pin/${vid}`"
      data-pin-terse="true"
      data-pin-do="embedPin"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { EmbedAttributes } from '~/types/components/Embed';
  import { createScriptIfNeeded, removeScript } from '~/utils/embeds';

  const PINIT_URL = 'https://assets.pinterest.com/js/pinit_main.js';

  export default defineNuxtComponent({
    name: 'PinterestEmbed',

    props: {
      elem: {
        type: Object as PropType<TContent<EmbedAttributes>>,
        required: true,
      },
    },
    computed: {
      vid(): string {
        return this.elem.attributes.vid;
      },
    },

    unmounted() {
      removeScript(PINIT_URL);
    },

    mounted() {
      createScriptIfNeeded(PINIT_URL).catch((err) => {
        console.error('PinterestEmbed: failed to load Pinterest script', err);
      });
    },
  });
</script>

<style lang="scss" scoped>
  .pinterest-embed {
    margin: 24px auto;
    width: 100%;

    @include mobile {
      max-width: 290px;
    }

    > :first-child {
      max-width: unset;
    }
  }
</style>
